import { useState, type FC, Dispatch } from 'react';

// MUI
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

// icons
// Removed MUI icons as we're now using emojis

// screen
import StyledLabel from 'modules/map/components/daily-dish/components/utils/StyledLabel';
import { SettingsAction } from 'modules/map/components/daily-dish/reducer';
import { MENU_EMOJIS } from 'modules/map/components/daily-dish/look/emojiCatalog';

const emoji = MENU_EMOJIS;

interface WeekDayIconSelectorProps {
  weekDay: string;
  backgroundColor: string;
  weekdayNumber: 2 | 3 | 4 | 5 | 6;
  selectedEmojiId: number;
  dispatch: Dispatch<SettingsAction>;
}

const WeekDayIconSelector: FC<WeekDayIconSelectorProps> = (props) => {
  const { weekDay, backgroundColor, weekdayNumber, selectedEmojiId, dispatch } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleShowIconsList = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectIcon = (emojiIndex: number) => {
    dispatch({
      type: 'UPDATE_WEEKDAY_EMOJI',
      weekday: weekdayNumber,
      emojiId: emojiIndex + 1, // 1-based index
    });
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <StyledLabel label={`Emoji ${weekDay}`} />
      <Box
        aria-describedby={id}
        component={'button'}
        onClick={handleShowIconsList}
        sx={{
          backgroundColor: '#fff',
          borderTopLeftRadius: '12px',
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '12px',
          borderTopRightRadius: '4px',
          height: '40px',
          width: '100%',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '6px 6px 10px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
          border: `2px solid ${backgroundColor}`,
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            flex: 1,
            alignSelf: 'stretch',
            alignContent: 'center',
          }}
        >
          {selectedEmojiId ? (
            // Render the selected emoji
            <Typography sx={{ fontSize: '24px' }}>{emoji[selectedEmojiId - 1]}</Typography>
          ) : (
            <Typography>-</Typography>
          )}
        </Box>
        <Box
          sx={{
            flex: 3,
            backgroundColor,
            alignSelf: 'stretch',
            alignContent: 'center',
            fontSize: '16px',
            fontWeight: 600,
          }}
        >
          {weekDay}
        </Box>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
          sx={{
            p: 2,
            width: '400px',
            maxHeight: '300px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          {emoji.map((emj, index) => (
            <Box
              key={index}
              onClick={() => handleSelectIcon(index)}
              sx={{ cursor: 'pointer', fontSize: '24px' }}
            >
              {emj}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default WeekDayIconSelector;
